import { createContext } from 'react';
export var PreferencesEditorDialogContext = createContext(null);
